'use client';

import dynamic from 'next/dynamic';
import { Container } from '@weareconceptstudio/core';

//* Components
import MainContent from '../components/MainContent';
const Subscribe = dynamic(() => import('@/sections/Subscribe'));
const RelatedEvents = dynamic(() => import('../components/RelatedEvents'));

//* Style
import EventsIndividualTemplateStyle from './style';

const EventsIndividualTemplate = ({ pageData }) => {
	return (
		<EventsIndividualTemplateStyle>
			<MainContent {...pageData} />

			<Container>
				<Subscribe />
			</Container>

			<RelatedEvents id={pageData.id} />
		</EventsIndividualTemplateStyle>
	);
};

export default EventsIndividualTemplate;
